import { authorizationHeaders } from "@/services/helpers";
import { useEffect, useState } from "react";
import SwaggerUI from "swagger-ui-react";

import { PageWrapper, StickyActionsHeader } from "@/components";
import { CONTENT_WIDTH } from "@/enums";
import { Alert, Button, Col, Row, Tag, Typography } from "antd";
import { useIntl } from "react-intl";
import "swagger-ui-react/swagger-ui.css";

const Swagger = () => {
  const [headers, setHeaders] = useState(null);
  const intl = useIntl();

  const open = (token) => {
    const win = window.open(
      "https://jwt.io/#debugger-io?token=" + encodeURIComponent(token),
      "_blank"
    );
    if (win != null) {
      win.focus();
    }
  };

  useEffect(() => {
    async function getHeaders() {
      const headers = await authorizationHeaders(new Headers());
      setHeaders(headers);
    }

    if (!headers) getHeaders().then();
  }, [headers]);

  return (
    <PageWrapper
      pageTitle={intl.formatMessage({ id: `swagger.title` })}
      noBackButton
      pageActions={
        headers && (
          <StickyActionsHeader
            leftChildren={
              <>
                Session Based CompanyCode:
                <Tag color="green">{headers.get("CompanyCode")}</Tag>
              </>
            }
            rightChildren={
              <>
                <Col
                  xxl={CONTENT_WIDTH.oneQuarter}
                  lg={CONTENT_WIDTH.oneQuarter}
                  sm={CONTENT_WIDTH.half}
                  xs={CONTENT_WIDTH.max}
                >
                  <Button
                    data-test-id="inspect-tokens"
                    type="primary"
                    onClick={() =>
                      open(
                        headers
                          .get("Authorization")
                          .split(" ")
                          .slice(1)
                          .join(" ")
                      )
                    }
                  >
                    {intl.formatMessage({
                      id: "swagger.inspectBearerTokenButton",
                    })}
                  </Button>
                </Col>
                <Col
                  xxl={CONTENT_WIDTH.oneQuarter}
                  lg={CONTENT_WIDTH.oneQuarter}
                  sm={CONTENT_WIDTH.half}
                  xs={CONTENT_WIDTH.max}
                >
                  <Button
                    data-test-id="inspect-tokens"
                    type="primary"
                    onClick={() => open(headers.get("met-users-token"))}
                  >
                    {intl.formatMessage({
                      id: "swagger.inspectMetUsersTokenButton",
                    })}
                  </Button>
                </Col>
              </>
            }
          />
        )
      }
    >
      <Alert message={intl.formatMessage({ id: "swagger.note" })} type="info" />

      <Row justify="center">
        <Typography.Title level={5}>
          {intl.formatMessage({ id: "swagger.description" })}
        </Typography.Title>
      </Row>

      {headers && (
        <SwaggerUI
          url="/swagger/v1/swagger.json"
          withCredentials
          tryItOutEnabled
          requestInterceptor={(req) => {
            req.headers.Authorization = headers.get("Authorization");
            req.headers["met-users-token"] = headers.get("met-users-token");
            if (!req.headers.CompanyCode) {
              req.headers.CompanyCode = headers.get("CompanyCode");
            }
            return req;
          }}
        />
      )}
    </PageWrapper>
  );
};

export default Swagger;
